import React, { CSSProperties } from 'react';

interface UserGroupProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const UserGroup: React.FC<UserGroupProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g fill={fill}>
        <defs />
        <circle className="cls-1" cx="531.64" cy="380.55" fill="none" r="95.86" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <circle className="cls-1" cx="757.28" cy="427.14" fill="none" r="60.71" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <circle className="cls-1" cx="302.72" cy="427.14" fill="none" r="60.71" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <path className="cls-1" d="M322.48 727.38s11.79-191.71 203.89-191.71 227.47 191.71 227.47 191.71-131.99 47.93-227.47 47.93-203.89-47.93-203.89-47.93z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <path className="cls-1" d="M753.94 550.68c-40.42 0-68.23 13.4-87.35 31.3 47.27 37.84 70.3 89.87 80.39 120.34 2.33.09 4.65.13 6.96.13 60.47 0 144.06-30.35 144.06-30.35s-22.4-121.42-144.06-121.42z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <path className="cls-1" d="M306.06 550.68c40.42 0 68.23 13.4 87.35 31.3-47.27 37.84-70.3 89.87-80.39 120.34-2.33.09-4.65.13-6.96.13-60.47 0-144.06-30.35-144.06-30.35s22.4-121.42 144.06-121.42z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
      </g>
    </svg>
  );
};

export default UserGroup;
